import { Ban } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'

import { useCancelJob, type Job } from '@/api/endpoints/jobs'
import { Button } from '@/components/ui/Button'
import { DialogClose, DialogContent, DialogRoot } from '@/components/ui/Dialog'
import { errorMessage } from '@/lib/errors'

export interface CancelJobButtonProps {
  job: Job
  className?: string
}

/**
 * Cancelar um job da fila, com confirmação (docs/plan-job-queue.md, F2). Só
 * aparece com `cancellable === true`: um backend anterior não manda o campo,
 * e aí o botão some sozinho. O aviso de "cancelado" vem do `JobsWatcher`.
 */
export function CancelJobButton({ job, className }: CancelJobButtonProps) {
  const [open, setOpen] = useState(false)
  const cancel = useCancelJob()
  if (job.cancellable !== true) return null

  function confirm() {
    cancel.mutate(job.id, {
      onSuccess: () => {
        setOpen(false)
      },
      onError: (err) => {
        toast.error(errorMessage(err, 'Não foi possível cancelar o job.'))
      },
    })
  }

  return (
    <>
      <Button
        variant="secondary"
        size="sm"
        className={className}
        leadingIcon={<Ban aria-hidden />}
        onClick={() => {
          setOpen(true)
        }}
      >
        Cancelar
      </Button>
      <DialogRoot
        open={open}
        onOpenChange={(next) => {
          if (!next) setOpen(false)
        }}
      >
        <DialogContent
          title="Cancelar este job?"
          footer={
            <>
              <DialogClose asChild>
                <Button variant="secondary" disabled={cancel.isPending}>
                  Voltar
                </Button>
              </DialogClose>
              <Button variant="danger" onClick={confirm} disabled={cancel.isPending}>
                {cancel.isPending ? 'Cancelando…' : 'Cancelar job'}
              </Button>
            </>
          }
        >
          <p>O trabalho em andamento para; o que já terminou fica.</p>
        </DialogContent>
      </DialogRoot>
    </>
  )
}
